import { NumberOptionAction } from '../actions/NumberOptionAction'
import { SequenceManagerAction } from "../actions/SequenceManagerAction";

const initState = {
  requestBody: {
    sectionId: "NumberOption",
    steps: [
      {
        sequence: "0",
        stepId: "NumberOption",
        offerContainerId: "",
        options: [
          {
            name: "numberOption",
            value: "",
            fields: [
              {
                name: "Request Type",
                value: "",
              }
            ],
          },
        ]
      },
    ],
  },
}

const NumberOptionReducer = (state: any = initState, action: any) => {
  const { type } = action;
  const { payload } = action;
  var NumberValue = { ...state.requestBody.steps };

  switch (type) {
    case NumberOptionAction.MAKE_SELECTION:
      NumberValue[0].options[0].value = payload.selection;
      NumberValue[0].options[0].fields[0].value = payload.selectionText;
      NumberValue[0].offerContainerId = payload.offerContainerId;
      return state;

    case SequenceManagerAction.GET_CHECKOUT_SUCCESS:
      let section = payload.sections.filter((section: any) => {
        return (section.sectionId === 'NumberOption')
      });
      if (section.length > 0) {
        let numberTypeValue = section[0].steps[0].options[0];
        NumberValue[0].offerContainerId = section[0].steps[0].offerContainerId;
        NumberValue[0].options[0].value = numberTypeValue ? numberTypeValue.value : "";
        NumberValue[0].options[0].fields[0].value = numberTypeValue ? numberTypeValue.fields[0].value : "";
      }
      return state;

    default:
      return state;
  }
}

export default NumberOptionReducer;